import * as React from 'react';
import { ButtonModal } from 'sos-common/js/components/ButtonModal/ButtonModal';
import { SaveOrder } from 'sos-eservice-common/js/components/EServiceFormMenu/SaveOrder/SaveOrder';
import { makeTranslator } from 'sos-common/js/utils/translations';
import { MessageBanner } from 'sos-common/js/components/MessageBanner/messageBanner';
import { ResourceItem } from 'sos-common/js/commonTypes/resourceItem';

export interface IAnsokanSaveCloseBarProps {
  closeRedirect?: string;
  singleButton?: boolean;
  translations?: ResourceItem[];
}

export interface IAnsokanSaveCloseBarState {
  showSavedBanner: boolean;
}
let Translations: (key: string, defaultValue?: string) => string;
export class AnsokanSaveCloseBar extends React.Component<IAnsokanSaveCloseBarProps, IAnsokanSaveCloseBarState> {
  constructor(props: IAnsokanSaveCloseBarProps) {
    super(props);
    Translations = makeTranslator(props.translations);
    this.state = {
      showSavedBanner: false,
    };
  }

  closeSavedBanner = () => {
    this.setState({
      showSavedBanner: false,
    });
  };

  save = () => {
    this.setState({
      showSavedBanner: true,
    });
  };

  saveAndClose = () => {
    if (this.props.closeRedirect) {
      window.location.href = this.props.closeRedirect;
    }
  };

  close = () => {
    if (this.props.closeRedirect) {
      window.location.href = this.props.closeRedirect;
    }
  };

  renderSingleButton = () => {
    return (
      <button className="button eservice-navigation__saveorderbtn" onClick={this.close}>
        {Translations('singleButtonSave', 'Spara och stäng')}{' '}
      </button>
    );
  };

  renderTwoButtons = () => {
    return (
      <>
        <span>{Translations('SaveInformation')}</span>
        <SaveOrder
          buttonText={Translations('saveForm')}
          onAction={this.save}
          buttonCss={'button eservice-navigation__saveorderbtn'}
        />
        <ButtonModal
          buttonText={Translations('closeForm')}
          buttonCss="button button--white"
          modalAction=""
          modalHeading={Translations('closeForm')}
          modalBody={Translations('wantToCloseText')}
          modalCancelText={Translations('abortModal')}
          modalCancelCss="button button--white"
          modalActionText={Translations('closeForm')}
          modalActionCss="button"
          modalActionUrl="#"
          callBackLink="#"
          onActionCompleted={this.saveAndClose}
        />
      </>
    );
  };

  public render() {
    const { singleButton } = this.props;
    const { showSavedBanner } = this.state;

    return (
      <>
        {showSavedBanner && (
          <div className="message-banner-wrapper">
            <MessageBanner onClose={this.closeSavedBanner} />
          </div>
        )}
        <section className="ansokan-save-close-bar" aria-label="Kontroller för formuläret">
          {singleButton && this.renderSingleButton()}
          {!singleButton && this.renderTwoButtons()}
        </section>
      </>
    );
  }
}
